<template>
         <v-container class="beginningContainer pa-0">
                  <div style="width:100%; height:6vh; border-bottom:2px solid #efefef;" class="pl-3 pt-3 pb-3">
                    <!-- //TO PUT THE MESSAGE SUBJECT -->
                      <p> <v-icon class="mr-2">chat</v-icon> <b>{{subject}}swqewtehg</b> </p>
                  </div>
               <v-list three-line>
                <wb-messages v-for="message in messages" :key="message._id" v-if="message.userId != user._id" :message="message.message" :date="message.date" :user="getUser(message.userId)" ></wb-messages>
                <wb-messages-own v-else :message="message.message" :date="message.date" :user="getUser(message.userId)" ></wb-messages-own>
               </v-list>
                <quill-editor class="editor-example snow"
                      ref="myTextEditor"
                      v-model="newMessage"
                      :options="editorOption"
                      >
                </quill-editor>
                <v-btn primary @click="sendMessage" class="mt-5 ml-3">Send <v-icon right>send</v-icon></v-btn>
                <v-btn color="primary" class="mt-5" @click="emitClose"> close</v-btn>
        </v-container>
</template>

<script>
import messages from "./MessageTemplate.vue";
import messagesOwn from "./MessageTemplateLeft.vue";
import { quillEditor } from "vue-quill-editor";
import axios from "axios";
export default {
  data() {
    return {
      newMessage: "",
      editorOption: {
        theme: "snow",
        placeholder: "Send a new Message",
        modules: {
          toolbar: [
            ["bold", "italic"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"]
          ]
        }
      }
    };
  },
  components: {
    "wb-messages": messages,
    "wb-messages-own": messagesOwn,
    quillEditor
  },
  computed: {
        token() {
      return this.$store.getters.getToken;
    },
    user() {
      return this.$store.getters.getUser;
    },
    editor() {
      return this.$refs.myTextEditor.quill;
    }
  },
  props: ["messages", "subject", "conversationId"],
  methods: {
    emitClose()
    {
      this.$emit('closed')
    },
    sendMessage() {
      axios
        .post("/api/messages", {
          message: this.newMessage,
          userId: this.user._id,
          id: this.conversationId,
          token:this.token
        })
        .then(response => {
          this.$emit("newMessage", this.conversationId);
          this.newMessage = "";
        });
    },
    getUser(userId) {
      return this.$store.getters.loadSingleUser(userId);
    }
  }
};
</script>

<style>
.ql-container {
  font-family: "Roboto", sans-serif !important;
}
</style>


<style lang="scss" scoped>
.quill-editor,
.quill-code {
  height: 10rem;

  font-family: "Roboto", sans-serif;
}
.quill-editor {
  border-bottom: none;
  padding: 1rem;
  font-family: "Roboto", sans-serif;
}
.quill-code {
  border: none;
  height: auto;
  > code {
    font-family: "Roboto", sans-serif;
    width: 70%;
    margin: 10px;
    padding: 1rem;
    border: 1px solid #ccc;
    border-radius: 0;
    height: 10rem;
    overflow-y: auto;
  }
}
</style>

<style src='@/../static/quill.snow.css'>


// WEBPACK FOOTER //
// src/components/Partials/ConversationTemplate.vue